import { CloseIcon } from 'assets/icons/CloseIcon'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { createFatigueOverride } from 'features/operations/fatigueSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { IFatigueOverrideFormState } from 'types/fatigue.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'

const initialState: IFatigueOverrideFormState = {
  user: null,
  approvedByUser: null,
  reason: null,
  validUntil: null,
}

const parseBasicUsers = (data: { data: { id: number; fullName: string }[] }) =>
  data.data.map((i) => ({ label: i.fullName, value: i.id }))

export const FatigueOverrideModal = ({ closeModal }: { closeModal: () => void }) => {
  const [state, setState] = useState<IFatigueOverrideFormState>(initialState)
  const dispatch = useDispatch<AppDispatch>()
  useFocusFirstInput()
  useModalClose(closeModal)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleSelect = (value: { label: string; value: number }, name: string) => {
    setState((prev) => ({ ...prev, [name]: value }))
  }

  const isValid =
    state.user?.value && state.approvedByUser?.value && state.reason.trim() && state.validUntil

  const handleSave = async () => {
    const resp = await dispatch(createFatigueOverride(state))
    if (resp.meta.requestStatus === 'fulfilled') {
      closeModal()
    }
  }

  return (
    <Modal black>
      <Flex column between center>
        <Flex column gap='1rem' width='100%'>
          <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
            <TitleText weight='bold'>Add Override</TitleText>
            <CursorPointer onClick={closeModal}>
              <CloseIcon />
            </CursorPointer>
          </Flex>
          <HonestSelectAsyncInput
            nomarg
            link='users/basic'
            name='user'
            labelText='Worker'
            placeholder='Search worker'
            required
            invalid={!state.user?.value}
            onChange={(v) => handleSelect(v, 'user')}
            parserFunction={parseBasicUsers}
          />
          <HonestSelectAsyncInput
            nomarg
            link='users/basic'
            name='approvedByUser'
            labelText='Approved by'
            placeholder='Search approver'
            required
            invalid={!state.approvedByUser?.value}
            onChange={(v) => handleSelect(v, 'approvedByUser')}
            parserFunction={parseBasicUsers}
          />
          <Input
            nomarg
            name='reason'
            type='textarea'
            height='6rem'
            labelText='Reason'
            placeholder='Enter override reason...'
            value={state.reason}
            onChange={handleChange}
            required
            invalid={!state.reason.trim()}
          />
          <CalendarInput
            nomarg
            labelText='Valid until'
            includeTime
            minDate={new Date()}
            defaultValue={state.validUntil}
            onChange={(date) => setState((prev) => ({ ...prev, validUntil: date }))}
          />
        </Flex>
        <Button mt='16' disabled={!isValid} orange onClick={handleSave}>
          Save
        </Button>
      </Flex>
    </Modal>
  )
}
